import React, { useState } from "react";
import { Col, Form, Row, Tab, Tabs, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import ReactLoading from "react-loading";
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO,
    getTime,
    formatTime
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";

import { getAllFranchisee } from "../../../Helpers/apiCalls/franchiseeApi";
import { getAttendance, getAllAttendance, searchAttendance, addOvertime } from "../../../Helpers/apiCalls/Reports/DailyAttendanceApi";
import { getAllEmployees } from './../../../Helpers/apiCalls/employeesApi';
import Footer from "../../../Components/Footer/Footer";


export default function SalesByItem() {
    const { type, id, date, date_to, shop } = useParams();
    const { state } = useLocation();
    
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [isClicked, setIsClicked] = useState(false);
    const [franchisees, setFranchisees] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [sales, setSales] = useState([]);
    const [dayoff, setDayoff] = useState("");
    const [absences, setAbsences] = useState("");
    const [attendance, setAttendance] = useState([]);
    const [totalQuantity, setTotalQuantity] = useState([]);
    const [averagePrice, setAveragePrice] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [totalHours, setTotalHours] = useState(0);
    const [excelData, setExcelData] = useState([]);
    const [excelDataForEmployee, setExcelDataForEmployee] = useState([]);
    const [branchName, setBranchName] = useState("");
    const today = Moment().format("MM/DD/YYYY");
    /* delete modal handler */
    const [showAddOTModal, setShowAddOTModal] = useState(false);
    const handleShowAddOTModal = () => setShowAddOTModal(true);
    const handleCloseAddOTModal = () => setShowAddOTModal(false); 

    const [addDetails, setAddDetails] = useState({})
    const [filterConfig, setFilterConfig] = useState({
        branch_id: type === "branch" ? id : "",
        date: type === "branch" ? date : "",
        by_employees: type === "branch" ? true : false,

        employee_id: type === "employee" ? id : "",
        date_from: type === "employee" ? date : "",
        date_to: type === "employee" ? date_to : "",
        group_datetime: type === "employee" ? 1 : "",
    })

    const xlsxHeaders =  [ "NAME", "BRANCH", "OPERATION TIME", "ACTIVITY LOG", "IN", "OUT", "IN", "OUT", "IN", "OUT", "TOTAL HOURS" ]
    const xlsxHeadersForEmployee =  [ "NAME", "DATE", "TOTAL HOURS", "OT HOURS", "UNDERTIME", "BRANCH", "IN", "OUT", "IN", "OUT", "IN", "OUT", "SCHEDULED BREAK HOURS" ]

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleAddOTChange(e, type) {
        if(type === "select") {
            setSelectedRow((prev) => {
                return { 
                    ...prev, 
                    [e.for]: e.value,
                    [e.select_value]: {
                        for: e.for,
                        label: e.label,
                        value: e.value,
                    }
                };
            });
        } else {
            const { name, value } = e.target;
            
            setSelectedRow((prev) => {
                return { ...prev, [name]: value };
            });
        }
    }
    

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handleView(row.id, row.franchisee_id, row.payable_id, row.type)}
            >
                View
            </button>
        );
    }
    function handleView(id, type, shop) {
        

    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);

        if (e.target.value === "add_ot") {
            handleShowAddOTModal();
        } else if (e.target.value === "edit") {
            navigate("/attendance/manual/" + row.id);
        }
    }
    
    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { (accountType === "admin" || accountType === "operations_manager") ? (
                    <option value="edit" className="color-options">
                        Edit
                    </option>
                    ): null
                }
                { (accountType === "admin" || accountType === "operations_manager") ? (
                    <option value="add_ot" className="color-options">
                        Add OT
                    </option>
                    ): null
                }
            </Form.Select>
        );
    }
    
    async function fetchEmployees() {

        const response = await getAllEmployees();
        if (response.error) {
            setEmployees([])
        } else {
            let result = response.data.data.map((data) => {
                var employee = data;
                employee.for = "added_by_id"
                employee.select_value = "added_by_id_value"
                employee.label = data.first_name + " " + data.last_name;
                employee.value = data.id;
                return employee;
            });
            setEmployees(result);
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setSales([])
        setExcelData([])
        setExcelDataForEmployee([])

        if(shop === "braddex") {
            const response = await searchAttendance(filterConfig);
            
    
            if (response.error) {
                
            } else {
                setBranchName(type === "branch" ? response.data.data[0].branch_name : response.data.data[0].employee_name );
                setTotalHours(type === "employee" ? numberFormat((response.data.total_minutes_per_employee)/60) : "0");

                if(type === "employee") {
                    var absentDates = response.data.absences?.map(data => Moment(data.absent).format("MMM, DD, YYYY"));
                    const combinedStringAbsences = absentDates.join(', ');
                    setAbsences(combinedStringAbsences)
    
                    var dayoffDates = response.data.dayoff?.map(date => Moment(date.dayoff).format("MMM, DD, YYYY"));
                    const combinedStringDayoff = dayoffDates.join(', ');
                    setDayoff(combinedStringDayoff)
                }

                var allBills = response.data.data.map((bill) => {
                    var info = bill;
                    info.datetime = Moment(bill.datetime).format("MM-DD-YYYY")
                    info.total_hours = numberFormat(parseFloat(bill.total_minutes)/60)
                    info.overtime = numberFormat(bill.overtime)
                    info.undertime = numberFormat(parseFloat(bill.undertime)/60)
                    const greenStyle = { color: "green" };
                    const redStyle = { color: "red" };
                    info.time_in_1 = bill?.attendance_entries[0]?.time_in? bill?.attendance_entries[0]?.actual_timein? (
                          <span>
                            <span style={greenStyle}>{getTime(bill.attendance_entries[0]?.time_in)}</span><br/> 
                            <span style={redStyle}>({getTime(bill.attendance_entries[0]?.actual_timein)})</span>
                          </span>
                        )
                      : <span style={greenStyle}>{getTime(bill.attendance_entries[0]?.time_in)}</span>
                    : "";
                    info.time_out_1 = bill?.attendance_entries[0]?.time_out ? bill?.attendance_entries[0]?.actual_timeout ? (
                          <span>
                            <span style={greenStyle}>{getTime(bill.attendance_entries[0]?.time_out)}</span><br/> 
                            <span style={redStyle}>({getTime(bill.attendance_entries[0]?.actual_timeout)})</span>
                            </span>
                        )
                      : <span style={greenStyle}>{getTime(bill.attendance_entries[0]?.time_out)}</span>
                      : "";
                    info.time_in_2 = bill?.attendance_entries[1]?.time_in ? bill?.attendance_entries[1]?.actual_timein ? (
                          <span>
                            <span style={greenStyle}>{getTime(bill.attendance_entries[1]?.time_in)}</span><br/> 
                            <span style={redStyle}>({getTime(bill.attendance_entries[1]?.actual_timein)})</span>
                          </span>
                        )
                      : <span style={greenStyle}>{getTime(bill.attendance_entries[1]?.time_in)}</span>
                    : "";
                    info.time_out_2 = bill?.attendance_entries[1]?.time_out ? bill?.attendance_entries[1]?.actual_timeout ? (
                        <span>
                          <span style={greenStyle}>{getTime(bill.attendance_entries[1]?.time_out)}</span><br/> 
                          <span style={redStyle}>({getTime(bill.attendance_entries[1]?.actual_timeout)})</span>
                          </span>
                      )
                    : <span style={greenStyle}>{getTime(bill.attendance_entries[1]?.time_out)}</span>
                    : "";
                    info.time_in_3 = bill?.attendance_entries[2]?.time_in ? bill?.attendance_entries[2]?.actual_timein ? (
                          <span>
                            <span style={greenStyle}>{getTime(bill.attendance_entries[2]?.time_in)}</span><br/> 
                            <span style={redStyle}>({getTime(bill.attendance_entries[2]?.actual_timein)})</span>
                          </span>
                        )
                      : <span style={greenStyle}>{getTime(bill.attendance_entries[2]?.time_in)}</span>
                    : "";
                    info.time_out_3 = bill?.attendance_entries[2]?.time_out ? bill?.attendance_entries[2]?.actual_timeout ? (
                        <span>
                          <span style={greenStyle}>{getTime(bill.attendance_entries[2]?.time_out)}</span><br/> 
                          <span style={redStyle}>({getTime(bill.attendance_entries[2]?.actual_timeout)})</span>
                          </span>
                      )
                    : <span style={greenStyle}>{getTime(bill.attendance_entries[2]?.time_out)}</span>
                    : "";
                    
                    var open_time = formatTime(bill.opening_time)
                    var close_time = bill.closing_time !== "" ? formatTime(bill.closing_time) : "Ongoing"

                    info.activity_log = open_time + " - " + close_time
                    info.operation_time = formatTime(bill.operation_time.split("-")[0]) + " - " + formatTime(bill.operation_time.split("-")[1])
                    return info;
                });
                setSales(allBills)               

                var excel = response.data.data.map((bill) => {
                    var info = {};
                    
                    var opening_time = formatTime(bill.opening_time)
                    var closing_time = bill.closing_time !== "" ? formatTime(bill.closing_time) : "Ongoing"
                    
                    info.employee_name = bill.employee_name
                    info.branch_name = bill.branch_name
                    info.operation_time = bill.operation_time
                    info.activity_log = opening_time + " - " + closing_time

                    info.time_in_1 = bill?.attendance_entries[0]?.time_in ? bill?.attendance_entries[0]?.actual_timein ? 
                                    getTime(bill.attendance_entries[0]?.time_in) + " (" + getTime(bill.attendance_entries[0]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[0]?.time_in)  : ""
                    info.time_out_1 = bill?.attendance_entries[0]?.time_out ? bill?.attendance_entries[0]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[0]?.time_out) + " (" + getTime(bill.attendance_entries[0]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[0]?.time_out) : ""
                    info.time_in_2 = bill?.attendance_entries[1]?.time_in ? bill?.attendance_entries[1]?.actual_timein ? 
                                    getTime(bill.attendance_entries[1]?.time_in) + " (" + getTime(bill.attendance_entries[1]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[1]?.time_in)  : ""
                    info.time_out_2 = bill?.attendance_entries[1]?.time_out ? bill?.attendance_entries[1]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[1]?.time_out) + " (" + getTime(bill.attendance_entries[1]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[1]?.time_out) : ""
                    info.time_in_3 = bill?.attendance_entries[2]?.time_in ? bill?.attendance_entries[2]?.actual_timein ? 
                                    getTime(bill.attendance_entries[2]?.time_in) + " (" + getTime(bill.attendance_entries[2]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[2]?.time_in)  : ""
                    info.time_out_3 = bill?.attendance_entries[2]?.time_out ? bill?.attendance_entries[2]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[2]?.time_out) + " (" + getTime(bill.attendance_entries[2]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[2]?.time_out) : ""
                    info.total_hours = numberFormat(parseFloat(bill.total_minutes)/60)
                    return info;
                });
                setExcelData(excel)

                var excelEmployee = response.data.data.map((bill) => {
                    var info = {};
                    info.employee_name = bill.employee_name
                    info.datetime = Moment(bill.datetime).format("MM-DD-YYYY")
                    info.total_hours = numberFormat(parseFloat(bill.total_minutes)/60)
                    info.overtime = numberFormat(bill.overtime)
                    info.undertime =  bill.undertime
                    info.branch_name = bill.branch_name
                    info.time_in_1 = bill?.attendance_entries[0]?.time_in ? bill?.attendance_entries[0]?.actual_timein ? 
                                    getTime(bill.attendance_entries[0]?.time_in) + " (" + getTime(bill.attendance_entries[0]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[0]?.time_in)  : ""
                    info.time_out_1 = bill?.attendance_entries[0]?.time_out ? bill?.attendance_entries[0]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[0]?.time_out) + " (" + getTime(bill.attendance_entries[0]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[0]?.time_out) : ""
                    info.time_in_2 = bill?.attendance_entries[1]?.time_in ? bill?.attendance_entries[1]?.actual_timein ? 
                                    getTime(bill.attendance_entries[1]?.time_in) + " (" + getTime(bill.attendance_entries[1]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[1]?.time_in)  : ""
                    info.time_out_2 = bill?.attendance_entries[1]?.time_out ? bill?.attendance_entries[1]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[1]?.time_out) + " (" + getTime(bill.attendance_entries[1]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[1]?.time_out) : ""
                    info.time_in_3 = bill?.attendance_entries[2]?.time_in ? bill?.attendance_entries[2]?.actual_timein ? 
                                    getTime(bill.attendance_entries[2]?.time_in) + " (" + getTime(bill.attendance_entries[2]?.actual_timein) + ")" : 
                                    getTime(bill.attendance_entries[2]?.time_in)  : ""
                    info.time_out_3 = bill?.attendance_entries[2]?.time_out ? bill?.attendance_entries[2]?.actual_timeout ? 
                                    getTime(bill.attendance_entries[2]?.time_out) + " (" + getTime(bill.attendance_entries[2]?.actual_timeout) + ")" : 
                                    getTime(bill.attendance_entries[2]?.time_out) : ""
                    info.scheduled_break_hours = bill.scheduled_break_hours
                    return info;
                });
                setExcelDataForEmployee(excelEmployee)
            }
            setShowLoader(false);
        } 
    }
    
    async function handleAddOT() {
        setIsClicked(true)
        if(shop === "braddex") {
            const response = await addOvertime(selectedRow);
            
            if (response.error) {
                toast.error(response.error.response.data.messages.error, {
                    style: toastStyle(),
                });
            } else {
                toast.success("Successfully Updated Cash Advance Status!", {
                    style: toastStyle(),
                });
                setTimeout(() => {
                    refreshPage()
                }, 1000);
            }
        } 
    }
    
    function handleExport() {
        const rows = type === "employee" ? excelDataForEmployee : excelData
        
        var headers = type === "employee" ? xlsxHeadersForEmployee : xlsxHeaders
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
        XLSX.writeFile(workbook, "Attendance.xlsx", { compression: true });
    }

    React.useEffect(() => {
        fetchData();
        fetchEmployees();
    }, []);

    const legendStyle1 = {
        paddingLeft: "1rem",
        marginTop: "-2.3rem",
        color: "green",
        fontSize: "0.7rem",
        letterSpacing: 0,
      };
    const legendStyle2 = {
        paddingLeft: "1rem",
        color: "red",
        fontSize: "0.7rem",
        letterSpacing: 0,
      };

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                <Row className="mb-4">
                    <Col xs={6}>
                        <h1 className="page-title"> {branchName} </h1>
                    </Col>
                </Row>
                {type === "branch" && (<Row className="mb-4">
                    <Col xs={6}>
                        <h5 className="page-subtitle"> {new Date(filterConfig.date).toLocaleDateString( "en-us", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} </h5>
                    </Col>
                    <Col xs={6} className="justify-content-end ">
                        <button
                            type="button"
                            className="button-primary me-3 right"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon}
                                ></img>
                            </span>
                            Download
                        </button>
                    </Col>
                </Row>)}
                {type === "employee" && (
                    <>
                    <Row className="mb-2">
                        <Col xs={6}>
                            <h5 className="page-subtitle"> {new Date(filterConfig.date_from).toLocaleDateString( "en-us", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
                            + " - " + new Date(filterConfig.date_to).toLocaleDateString( "en-us", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} </h5>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={12} className="break-word">
                            <span className="PI-modal-label red text-normal">
                                Absences: {" "} {absences !== "" ? absences : "None"}
                            </span>
                        </Col>
                    </Row>
                    <Row className="mb-2">
                        <Col xs={10} className="break-word">
                            <span className="PI-modal-label red text-normal">
                                Day Off: {" "} {dayoff !== "" ? dayoff : "None"}
                            </span>
                        </Col>
                        <Col xs={2} className="justify-content-end ">
                            <button
                                type="button"
                                className="button-primary me-3 right"
                                onClick={handleExport}
                            >
                                <span className="me-2">
                                    <img
                                        width={20}
                                        height={20}
                                        src={downloadIcon}
                                    ></img>
                                </span>
                                Download
                            </button>
                        </Col>
                    </Row>
                    </>
                )}

                <div className="tab-content">

                    <div className="below">
                        <div className="my-2 px-2 PO-filters d-flex justify-content-start">
                            <span className="me-4 align-left mt-2 ps-label">
                                Total Number of Hours: {numberFormat(totalHours)}
                            </span>
                        </div>
                        {/* table */}
                        {type === "branch" && (
                        <Table
                            tableHeaders={[
                                "NAME",
                                "BRANCH",
                                "OPERATION TIME",
                                "ACTIVITY LOG",
                                "IN",
                                "OUT",
                                "IN",
                                "OUT",
                                "IN",
                                "OUT",
                                "TOTAL HOURS",
                            ]}
                            headerSelector={[
                                "employee_name",
                                "branch_name",
                                "operation_time",
                                "activity_log",
                                "time_in_1",
                                "time_out_1",
                                "time_in_2",
                                "time_out_2",
                                "time_in_3",
                                "time_out_3",
                                "total_hours",
                            ]}
                            tableData={sales}
                            ViewBtn={(row) => ViewBtn(row)}
                            showLoader={showLoader}
                        />)}

                        {type === "employee" && (
                        <Table
                            tableHeaders={[
                                "DATE",
                                "SCHED BREAK HOURS",
                                "TOTAL HOURS",
                                "OT HOURS",
                                "UNDERTIME HOURS",
                                "BRANCH",
                                "IN",
                                "OUT",
                                "IN",
                                "OUT",
                                "IN",
                                "OUT",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "datetime",
                                "scheduled_break_hours",
                                "total_hours",
                                "overtime",
                                "undertime",
                                "branch_name",
                                "time_in_1",
                                "time_out_1",
                                "time_in_2",
                                "time_out_2",
                                "time_in_3",
                                "time_out_3",
                            ]}
                            tableData={sales}
                            ViewBtn={(row) => ViewBtn(row)}
                            ActionBtn={(row) => ActionBtn(row)}
                            showLoader={showLoader}
                        />)}
                        <div style={legendStyle1}>Adjusted Log</div>
                        <div style={legendStyle2}>Actual Log</div>
                    </div>
                    <div className="mb-2" />
                </div>
            </div>
            <div className="d-flex justify-content-end pt-5 pb-3 me-5">
                {type === "branch" && (<button
                    type="button"
                    className="button-secondary me-3"
                    onClick={() => navigate("/dailyattendancelist/view/employeehours/" + id + "/" + shop, 
                        {
                            state: { 
                                by_employees: true,
                                date: date ? new Date(date) : "",
                            },
                        }
                        )}
                >
                    Total Hours
                </button>)}
                {type === "branch" && (<button
                    type="button"
                    className="button-primary me-3"
                    onClick={() => navigate("/dailyattendancelist")}
                >
                    Close
                </button>)}
            </div>

            {/* MODALS */}
            <Modal show={showAddOTModal} onHide={()=>handleCloseAddOTModal()} size="lg" centered>
                <Modal.Header closeButton/>
                <Modal.Body className='pt-2'>
                    <div className='ms-2'>
                        <Row className="nc-modal-custom-row-view">
                            <Col xs={6}>
                                Total Hours
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        <Form.Control
                                            type="number"
                                            min={1}
                                            name="ot_hours"
                                            className="nc-modal-custom-text"
                                            value={selectedRow.ot_hours}
                                            onChange={(e) => handleAddOTChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6}>
                                Added By
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            placeholder="Select Employee..."
                                            value={selectedRow.added_by_id_value}
                                            options={employees}
                                            onChange={(e) => handleAddOTChange(e, "select")}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="nc-modal-custom-row-view mt-2">
                            <Col>
                                Remarks
                                <Row className="nc-modal-custom-row">
                                    <Col>
                                        <Form.Control
                                            type="text"
                                            name="remarks"
                                            className="nc-modal-custom-text"
                                            value={selectedRow.remarks}
                                            onChange={(e) => handleAddOTChange(e)}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        
                    </div>
                    <div className='d-flex justify-content-end my-4'>
                        <button
                            className="button-warning-fill me-2"
                            onClick={handleCloseAddOTModal}
                        >
                            Cancel
                        </button>
                        {
                            isClicked && (
                                <div className="button-primary d-flex justify-content-center">
                                    <ReactLoading
                                        type="bubbles"
                                        color="#FFFFFF"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            )
                        }
                        {
                            !isClicked && (
                                <button
                                    className="button-primary"
                                    onClick={()=> handleAddOT()}
                                >
                                    Add
                                </button>
                            )
                        }
                    </div>
                
                </Modal.Body>
            </Modal>
            <Footer/>
        </div>
    );
}
